import {Print} from "@mui/icons-material"
import React from "react"
import {AvantPopperButton} from "../../../generic-components/AvantPopperButton"
import {AvantPopperMenu, AvantPopperMenuProps} from "../../../generic-components/AvantPopperMenu"

export const ReportsPrintButton = (props: AvantPopperMenuProps ) => {

    return (
        <AvantPopperButton
            title={<Print/>}
        >
            <AvantPopperMenu contents={props.contents}/>
        </AvantPopperButton>
    )
}
